import React from "react";
import HeroCustom from './herocustom';
import ContactForm from './ContactForm';



function Index() {
    return (
        <div>
            <HeroCustom />
            <ContactForm />           
        </div>

    );
}

export default Index;